import React from "react";
import { SvgIcon } from "@mui/material"
import logo from "../../shared/img/collections-star-icon.svg"

export function CollectionsStarIcon() {
  return (
    <SvgIcon
      component={() => <img src={logo} alt="collections-star-icon" />}
      inheritViewBox
    />
  )
}